<div class="flex gap-4" [ngClass]="{ hidden: hidden }">
  <div class="flex gap-4" [ngClass]="[ fullWidth ? 'w-1/4' : 'w-1/5']">
    <div class="text-slate-200 mt-1">
          <span [ngClass]="{ 'text-theme-green': valid }">
          <lucide-angular [name]="valid ? CircleCheck : CircleMinus"></lucide-angular>
            </span>
    </div>
    <div>
      <div class="text-secondary font-semibold text-lg">
        <ng-content select="[title]"></ng-content>
      </div>
      <div class="text-slate-300 font-light text-sm">
        <ng-content select="[description]"></ng-content>
      </div>
    </div>
  </div>

  <div [ngClass]="[ fullWidth ? 'w-3/4' : 'w-2/5']">
    <app-card>
      <ng-content></ng-content>
    </app-card>
  </div>
</div>
